import React from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@mui/styles';

import {
  Paper,
  Table,
  Button,
  Switch,
  TableRow,
  TextField,
  TableHead,
  TableBody,
  Accordion,
  FormControlLabel,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';

import { ExpandMoreOutlined, ShowChartOutlined } from '@mui/icons-material';

import Node from '../../common/Node';
import Cell from '../../common/Cell';
import Loader from '../../common/Loader';
import Search from '../../common/Search';
import Predicate from '../../common/Predicate';
import ComponentWrapper from '../../common/ComponentWrapper';
import TrplSelect from '../../common/TrplControls/TrplSelect';

import CommonStyles from '../../common/CommonStyles';
import ParserPageStyles from './ParserPageStyles.js';
import { getRandomInteger, getConceptRsts } from '../../utils';

const styles = { ...CommonStyles, ...ParserPageStyles };

const newExit = {
  items: [],
  ancestor: '',
  primary_pid: '',
  strategy: 'IMPORTING',
  title_item: '',
  itemSelectPidValue: '',
  itemSelectValue: '',
};

const newItemState = {
  title: '',
  objective: '',
  start: '',
  end: '',
  id: '',
  edit: false,
};

class ParserPage extends ComponentWrapper {
  state = {
    parsers: [],
    loaded: false,
    editNewParser: false,
    editNewParserName: '',
    selectValues: {
      pids: [],
    },
  };

  getParserData = () => {
    const setup_tbox = this.props.setup_tbox;

    this.get({
      url: '/get_jel?type=["parser"]',
      cb: (res) => {
        const { ancestors } = res;
        const parsers = res.parser || [];

        // ancestors взять из метаквери

        parsers.forEach((parser) => {
          if (!parser.items) parser.items = [];
          if (!parser.exits) parsers.exits = [];
          parser.expanded = false;

          const newItemStateCopy = Object.assign({}, newItemState);

          if (parser.exits && parser.exits.length) {
            parser.exits.forEach((exit) => {
              exit.itemSelectValue = '';
              exit.itemSelectPidValue = '';
            });
          }

          parser.item = newItemStateCopy;
        });

        const selectValues = {};

        selectValues.pids = {};

        if (ancestors) {
          ancestors.forEach((ancestor) => {
            if (!selectValues.pids[ancestor.id]) selectValues.pids[ancestor.id] = [];
            const conceptRestrictions = getConceptRsts(ancestor.id, setup_tbox);
            ancestor.restrictions = conceptRestrictions;

            ancestor.restrictions.forEach((pid) => {
              selectValues.pids[ancestor.id].push({
                title: pid.title || pid.id,
                value: pid.id,
              });
            });
          });
        }

        this.setState({ parsers, ancestors, loaded: true, selectValues });
      },
    });
  };

  componentDidMount() {
    document.title="Parsers | Milkyweb";
  };

  componentDidUpdate(prevProps) {

    if (prevProps.setup_tbox !== this.props.setup_tbox) {
      this.getParserData();
    }
  };

  onInputChange = (key, e) => {
    this.setState({ [key]: e.target.value });
  };

  onEditNewParser = () => {
    this.setState({ editNewParser: true });
  };

  onAddNewParser = (e) => {
    e.preventDefault();

    const { parsers, editNewParserName } = this.state;

    const newItemStateCopy = Object.assign({}, newItemState);

    parsers.push({
      title: editNewParserName,
      items: [],
      exits: [],
      item: newItemStateCopy,
    });

    this.setState({ parsers, editNewParser: false, editNewParserName: '' });
  };

  onParserItemInputChange = (key, parserIndex, e) => {
    const { parsers } = this.state;

    parsers[parserIndex].item[key] = e.target.value;

    this.setState({ parsers });
  };

  onEditParserItem = (parserIndex, itemIndex) => {
    const { parsers } = this.state;
    const parser = parsers[parserIndex];
    const parserItem = parser.items[itemIndex];

    parserItem.edit = true;

    parser.item = parserItem;
    parser.item.parserIndex = parserIndex;

    this.setState({ parsers });
  };

  openAddItemForm = (parserIndex) => {
    const { parsers } = this.state;

    parsers[parserIndex].item.edit = true;

    this.setState({ parsers });
  };

  addItem = (parserIndex, e) => {
    e.preventDefault();

    const { parsers } = this.state;
    const parser = parsers[parserIndex];

    if (!parser.items) {
      parser.items = [];
    }

    let itemId = getRandomInteger(10000, 99999);
    parser.item.id = itemId;

    const isIdExist = (id) => {
      const existingIds = [];

      parsers.forEach((parser) => {
        parser.items.forEach((item) => existingIds.push(item.id));
      });

      if (!existingIds.includes(id)) {
        parser.item.id = id;
        parser.items.push(parser.item);

        parser.item = {
          title: '',
          objective: '',
          start: '',
          end: '',
          id: '',
        };

        this.setState({
          parsers,
          isItemModalOpened: false,
        });
      } else {
        isIdExist(getRandomInteger(10000, 99999));
      }
    };

    isIdExist(itemId);
  };

  editItem = (parserIndex) => {
    const { parsers } = this.state;

    const parser = parsers[parserIndex];
    const parserItem = parser.item;

    const itemIndex = parsers[parserIndex].items.findIndex((item) => item.id === parserItem.id);

    parsers[parserIndex].items[itemIndex] = parserItem;

    const newItemStateCopy = Object.assign({}, newItemState);

    parsers[parserIndex].item = newItemStateCopy;

    this.setState({
      parsers,
    });
  };

  onParserExitAncestorClick = (params) => {
    const { parsers, ancestors } = this.state;
    const { setup_tbox } = this.props;
    const { node } = params;
    const { parserIndex, exitIndex } = params.props;

    parsers[parserIndex].exits[exitIndex].ancestor = node.id;

    const anc = ancestors.find((anc) => anc.id === node.id);
    const conceptRestrictions = getConceptRsts(node.id, setup_tbox);

    if (!anc && conceptRestrictions) {
      node.restrictions = conceptRestrictions;
      ancestors.push(node);
    }

    const { selectValues } = this.state;

    if (ancestors) {
      ancestors.forEach((ancestor) => {
        if (!selectValues.pids[ancestor.id]) selectValues.pids[ancestor.id] = [];

        ancestor.restrictions.forEach((pid) => {
          selectValues.pids[ancestor.id].push({
            title: pid.title || pid.id,
            value: pid.id,
          });
        });
      });
    }

    this.setState({ parsers, ancestors, selectValues });
  };

  onParserExitAncestorRemoveClick = (parserIndex, exitIndex) => {
    const { parsers } = this.state;

    parsers[parserIndex].exits[exitIndex].ancestor = '';

    this.setState({ parsers });
  };

  onDeleteParserItem = (parserIndex, itemIndex) => {
    const { parsers } = this.state;

    parsers[parserIndex].items.splice(itemIndex, 1);

    this.setState({ parsers });
  };

  onDeleteParserExitItem = (parserIndex, exitIndex, exitItemIndex) => {
    const { parsers } = this.state;

    parsers[parserIndex].exits[exitIndex].items.splice(exitItemIndex, 1);

    this.setState({ parsers });
  };

  addExitItem = (parserIndex, exitIndex) => {
    const { parsers } = this.state;

    const exit = parsers[parserIndex].exits[exitIndex];

    const item = {};

    item.pid = exit.itemSelectPidValue;
    item.item = exit.itemSelectValue;

    exit.items.push(item);

    exit.itemSelectPidValue = '';
    exit.itemSelectValue = '';

    this.setState({ parsers });
  };

  onSaveParserClick = (parserIndex) => {
    const { parsers } = this.state;

    const parser = parsers[parserIndex];

    delete parser.expanded;

    if (parser.exits && parser.exits.length) {
      parser.exits.forEach((exit) => {
        delete exit.itemSelectValue;
        delete exit.itemSelectPidValue;
      });
    }

    delete parser.item;

    this.postWithData({
      url: '/rest/upd_jel?type=parser',
      data: parser,
      cb: (res) => {
        const newParser = res.parser;

        if (!newParser.items) {
          newParser.items = [];
        }

        const newItemStateCopy = Object.assign({}, newItemState);

        newParser.item = newItemStateCopy;
        newParser.expanded = true;

        newParser.exits.forEach((exit) => {
          exit.itemSelectValue = '';
          exit.itemSelectPidValue = '';
        });

        parsers.splice(parserIndex, 1, newParser);

        this.setState({ parsers });
      },
    });
  };

  onDeleteParserClick = (parserIndex) => {
    const { parsers } = this.state;

    this.get({ url: `/del_jel?id=${parsers[parserIndex].id}` });
    parsers.splice(parserIndex, 1);

    parsers.forEach((parser) => (parser.expanded = false));

    this.setState({ parsers });
  };

  toggleExpansionPanel = (parserIndex) => {
    const { parsers } = this.state;

    parsers[parserIndex].expanded = !parsers[parserIndex].expanded;

    this.setState({ parsers });
  };

  onParserTitleChange = (parserIndex, value) => {
    const { parsers } = this.state;

    parsers[parserIndex].title = value;

    this.setState({ parsers });
  };

  render() {
    const { loaded, parsers, ancestors, selectValues, editNewParser, editNewParserName } = this.state;

    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.mb20}>
          {editNewParser ? (
            <form onSubmit={this.onAddNewParser} className={classes.alignCenter}>
              <TextField
                label="Parser name"
                value={editNewParserName}
                onChange={(e) => this.onInputChange('editNewParserName', e)}
              />

              <Button
                size="small"
                type="submit"
                color="primary"
                variant="contained"
                disabled={!editNewParserName}
                className={classes.ml20}
                onClick={this.onAddNewParser}
              >
                Add
              </Button>
            </form>
          ) : (
            <Button size="small" color="primary" variant="contained" onClick={this.onEditNewParser}>
              Add new parser
            </Button>
          )}
        </div>

        {!loaded ? (
          <div className={classes.loaderContainer}>
            <Loader />
          </div>
        ) : null}

        <div>
          {parsers.length ? <span className={`${classes.columnHeadingGeneral} ${classes.mb20}`}>Parsers list:</span> : null}

          {parsers.map((parser, parserIndex) => {
            return (
              <Accordion
                onChange={() => this.toggleExpansionPanel(parserIndex)}
                style={{
                  opacity: `${parser.enabled ? '1' : '0.5'}`,
                }}
                expanded={parser.expanded}
                key={parserIndex}
              >
                <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
                  <div className={classes.alignCenter}>
                    <ShowChartOutlined />

                    <span className={classes.ml20}>{parser.title}</span>
                  </div>
                </AccordionSummary>
                <AccordionDetails >
                  <div style={{ width: '100%' }}>
                    <TextField
                      className={`${classes.mb20} ${classes.w200}`}
                      value={parser.title}
                      title="Title"
                      onChange={(e) => this.onParserTitleChange(parserIndex, e.target.value)}
                    />

                    {parser.items && parser.items.length ? <span className={classes.columnHeadingGeneral}>Items: </span> : null}

                    {parser.items && parser.items.length ? (
                      <Table className={classes.mb20}>
                        <TableHead>
                          <TableRow>
                            <Cell>Id</Cell>
                            <Cell>Title</Cell>
                            <Cell>Objective regex</Cell>
                            <Cell>Start regex</Cell>
                            <Cell>End regex</Cell>
                            <Cell />
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {parser.items.map((item, itemIndex) => {
                            return (
                              <TableRow key={itemIndex}>
                                <Cell>
                                  <span>{item.id}</span>
                                </Cell>

                                <Cell>
                                  <span>{item.title}</span>
                                </Cell>
                                <Cell>
                                  <pre>{item.objective}</pre>
                                </Cell>
                                <Cell>
                                  <pre>{item.start}</pre>
                                </Cell>
                                <Cell>
                                  <pre>{item.end}</pre>
                                </Cell>

                                <Cell>
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'flex-end',
                                    }}
                                  >
                                    <Button
                                      size="small"
                                      variant="contained"
                                      onClick={() => this.onEditParserItem(parserIndex, itemIndex)}
                                    >
                                      Edit
                                    </Button>

                                    <Button
                                      size="small"
                                      color="secondary"
                                      variant="contained"
                                      className={classes.ml10}
                                      onClick={() => this.onDeleteParserItem(parserIndex, itemIndex)}
                                    >
                                      Delete
                                    </Button>
                                  </div>
                                </Cell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    ) : null}

                    {parser.item.edit ? (
                      <form onSubmit={(e) => this.addItem(parserIndex, e)} className={classes.spaceBetween}>
                        <TextField
                          label="Title"
                          value={parsers[parserIndex].item.title}
                          style={{ width: '22%' }}
                          onChange={(e) => this.onParserItemInputChange('title', parserIndex, e)}
                          className={classes.mb10}
                        />

                        <TextField
                          label="Objective regex"
                          value={parsers[parserIndex].item.objective}
                          style={{ width: '22%' }}
                          onChange={(e) => this.onParserItemInputChange('objective', parserIndex, e)}
                          className={classes.mb10}
                        />

                        <TextField
                          label="Start regex"
                          value={parsers[parserIndex].item.start}
                          style={{ width: '22%' }}
                          onChange={(e) => this.onParserItemInputChange('start', parserIndex, e)}
                          className={classes.mb10}
                        />

                        <TextField
                          label="End regex"
                          value={parsers[parserIndex].item.end}
                          style={{ width: '22%' }}
                          onChange={(e) => this.onParserItemInputChange('end', parserIndex, e)}
                          className={classes.mb10}
                        />

                        {parsers[parserIndex].item.id ? (
                          <Button
                            size="small"
                            color="primary"
                            variant="contained"
                            type="submit"
                            onClick={(e) => this.editItem(parserIndex, e)}
                          >
                            Edit
                          </Button>
                        ) : (
                          <Button
                            size="small"
                            color="primary"
                            variant="contained"
                            type="submit"
                            onClick={(e) => this.addItem(parserIndex, e)}
                          >
                            Add
                          </Button>
                        )}
                      </form>
                    ) : null}

                    <div className={classes.justifyEnd}>
                      <Button
                        size="small"
                        color="primary"
                        variant="contained"
                        className={classes.mb10}
                        onClick={() => this.openAddItemForm(parserIndex)}
                      >
                        Add new item
                      </Button>
                    </div>

                    <div style={{ width: '100%' }}>
                      {parser.exits && parser.exits.length ? (
                        <span className={`${classes.columnHeadingGeneral}`}>Exits:</span>
                      ) : null}

                      {parser.exits && parser.exits.length ? (
                        <div
                          style={{
                            display: 'flex',
                            margin: '15px 0',
                            flexDirection: 'column',
                          }}
                        >
                          {parser.exits.map((exit, exitIndex) => {
                            const ancestor = ancestors.find((anc) => anc.id === exit.ancestor);

                            const exitInParser = parsers[parserIndex].exits[exitIndex];

                            const itemValues = [];
                            const pidValues = [{ title: 'none', value: 'none' }];
                            const itemIdAndTitleValues = [{ title: 'none', value: 'none' }];

                            if (parsers[parserIndex].items && parsers[parserIndex].items.length) {
                              parsers[parserIndex].items.forEach((item) => {
                                itemValues.push({
                                  title: item.title,
                                  value: item.id,
                                });

                                itemIdAndTitleValues.push({
                                  title: `${item.id} : ${item.title}`,
                                  value: item.id,
                                });
                              });
                            }

                            if (ancestor && ancestor.restrictions) {
                              ancestor.restrictions.forEach((pid) => {
                                pidValues.push({
                                  title: `${pid.id} : ${pid.title}`,
                                  value: pid.id,
                                });
                              });
                            }

                            return (
                              <Paper key={exitIndex} className={`${classes.mb10} ${classes.container}`}>
                                <div className={`${classes.mb10} ${classes.column}`}>
                                  <TextField
                                    label="Strategy"
                                    value={exit.strategy}
                                    onChange={() => {}}
                                    className={classes.mb10}
                                    disabled
                                  />

                                  <div className={`${classes.alignCenter}`}>
                                    <span className={classes.exitSearchAncestorTitle}>Ancestor:</span>

                                    {exit.ancestor ? (
                                      <Node
                                        nodeId={ancestor ? ancestor.id : ''}
                                        size="sm"
                                        node={
                                          ancestor && ancestor.id
                                            ? {
                                                id: ancestor.id,
                                                title: ancestor.title,
                                                color:ancestor.color,
                                              }
                                            : {}
                                        }
                                        isLink={true}
                                      />
                                    ) : (
                                      <Search
                                        searchValue={exit.ancestor}
                                        onDropdownElementClick={this.onParserExitAncestorClick}
                                        onDropdownElementClickProps={{
                                          parserIndex,
                                          exitIndex,
                                        }}
                                      />
                                    )}
                                  </div>
                                </div>

                                <div className={`${classes.alignCenter} ${classes.mb10} ${classes.w200}`}>
                                  <TrplSelect
                                    title="Primary predicate"
                                    complicatedValues
                                    values={
                                      selectValues && selectValues.pids[exit.ancestor]
                                        ? selectValues.pids[exit.ancestor]
                                        : []
                                    }
                                    value={exitInParser.primary_pid}
                                    onChange={(e) => {
                                      const { parsers } = this.state;

                                      exitInParser.primary_pid = e.target.value;

                                      this.setState({ parsers });
                                    }}
                                  />
                                </div>

                                <div className={`${classes.alignCenter} ${classes.mb10} ${classes.w200}`}>
                                  <TrplSelect
                                    margin="none"
                                    complicatedValues
                                    title="Title item"
                                    values={itemValues}
                                    value={exit.title_item}
                                    onChange={(e) => {
                                      const { parsers } = this.state;

                                      exitInParser.title_item = e.target.value;

                                      this.setState({ parsers });
                                    }}
                                  />
                                </div>

                                <div className={`${classes.alignCenter} ${classes.mb20}`}>
                                  <div className={`${classes.fw} ${classes.mr10}`}>
                                    <TrplSelect
                                      margin="none"
                                      complicatedValues
                                      title="Item"
                                      values={itemIdAndTitleValues}
                                      value={parsers[parserIndex].exits[exitIndex].itemSelectValue || 'none'}
                                      onChange={(e) => {
                                        const { parsers } = this.state;

                                        parsers[parserIndex].exits[exitIndex].itemSelectValue = e.target.value;

                                        this.setState({ parsers });
                                      }}
                                    />
                                  </div>

                                  {ancestor && ancestor.restrictions ? (
                                    <div className={`${classes.fw} ${classes.mr10}`}>
                                      <TrplSelect
                                        margin="none"
                                        title="Predicate"
                                        complicatedValues
                                        values={pidValues}
                                        value={parsers[parserIndex].exits[exitIndex].itemSelectPidValue || 'none'}
                                        onChange={(e) => {
                                          const { parsers } = this.state;

                                          parsers[parserIndex].exits[exitIndex].itemSelectPidValue = e.target.value;

                                          this.setState({ parsers });
                                        }}
                                      />
                                    </div>
                                  ) : null}

                                  <Button
                                    size="small"
                                    color="primary"
                                    variant="contained"
                                    style={{ marginTop: '8px' }}
                                    onClick={() => this.addExitItem(parserIndex, exitIndex)}
                                  >
                                    Add
                                  </Button>
                                </div>

                                {exit.items && exit.items.length ? (
                                  <Table className={`${classes.mb10} ${classes.exit} ${classes.p10}`}>
                                    <TableHead>
                                      <TableRow>
                                        <Cell>Item</Cell>

                                        <Cell>Predicate</Cell>

                                        <Cell />
                                      </TableRow>
                                    </TableHead>

                                    <TableBody>
                                      {exit.items.map((parserExitItem, parserExitItemIndex) => {
                                        const selectedItem = parsers[parserIndex].items.find(
                                          (item) => item.id === parserExitItem.item
                                        );

                                        const selectedPid =
                                          ancestor &&
                                          ancestor.restrictions &&
                                          ancestor.restrictions.find((anc) => anc.id === parserExitItem.pid);

                                        return (
                                          <TableRow key={parserExitItemIndex}>
                                            <Cell>
                                              {selectedItem ? `${selectedItem.id} : ${selectedItem.title}` : ''}
                                            </Cell>

                                            <Cell>
                                              <Predicate
                                                text={selectedPid ? `${selectedPid.id} : ${selectedPid.title}` : ''}
                                              />
                                            </Cell>

                                            <Cell>
                                              <div
                                                style={{
                                                  display: 'flex',
                                                  justifyContent: 'flex-end',
                                                }}
                                              >
                                                <Button
                                                  size="small"
                                                  color="secondary"
                                                  variant="contained"
                                                  onClick={() =>
                                                    this.onDeleteParserExitItem(
                                                      parserIndex,
                                                      exitIndex,
                                                      parserExitItemIndex
                                                    )
                                                  }
                                                >
                                                  Delete
                                                </Button>
                                              </div>
                                            </Cell>
                                          </TableRow>
                                        );
                                      })}
                                    </TableBody>
                                  </Table>
                                ) : null}
                              </Paper>
                            );
                          })}
                        </div>
                      ) : null}
                    </div>

                    <div className={`${classes.mb20} ${classes.justifyEnd}`}>
                      <Button
                        size="small"
                        color="primary"
                        variant="contained"
                        onClick={() => {
                          const { parsers } = this.state;
                          const parser = parsers[parserIndex];

                          if (!parser.exits) {
                            parser.exits = [];
                          }

                          const newExitCopy = Object.assign({}, newExit);

                          parser.exits.push(newExitCopy);

                          this.setState({ parsers });
                        }}
                      >
                        Add new exit
                      </Button>
                    </div>

                    <div className={classes.spaceBetween}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={parser.enabled}
                            onChange={(e) => {
                              const { parsers } = this.state;

                              parsers[parserIndex].enabled = e.target.checked;

                              this.setState({ parsers });

                              this.get({
                                url: `/enable_jel?id=${parser.id}&enable=${e.target.checked ? '1' : '0'}`,
                              });
                            }}
                            value="Enabled"
                          />
                        }
                        label="Enabled"
                      />

                      <div className={classes.alignCenter}>
                        <Button
                          size="small"
                          color="secondary"
                          variant="contained"
                          onClick={() => this.onDeleteParserClick(parserIndex)}
                        >
                          Delete parser
                        </Button>

                        <Button
                          size="small"
                          color="primary"
                          variant="contained"
                          className={classes.ml10}
                          onClick={() => this.onSaveParserClick(parserIndex)}
                        >
                          Save parser
                        </Button>
                      </div>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </div>
      </div>
    );
  }
}

export default connect((state) => ({ meta: state.meta, setup_tbox: state.meta.setup_tbox }))(withStyles(styles)(ParserPage));
